import React, { useRef, useState } from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok";
import Slider from "react-slick"
import * as styles from "./sideBarCta.module.css"

const BlogCarousel = ({ blok }) => {
  // console.log(blok);
  const widthMap = {
    'mid': 'md:w-[40vw]',
    'large': 'md:w-[70vw]',
    'full': 'md:w-full'
  }
  const widthClass = widthMap[blok.width] ? widthMap[blok.width] : 'md:w-[70vw]'

  const [currentSlide, setCurrentSlide] = useState(0)
  
  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }

  const settings = {
    arrows: true,
    autoplay: blok.autoplay,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    afterChange: current => setCurrentSlide(current)
  }

  return (
    <div className="flex justify-center" {...storyblokEditable(blok)} >
      <section className={`w-full ${widthClass} ${blok.displayText ? `h-[600px]` : `h-[300px] md:h-[600px]`} relative justify-items-center mx-auto my-12 overflow-hidden`} {...storyblokEditable(blok)}>
        <Slider ref={sliderRef} {...settings} className="w-full">{blok.carouselItems?.map((item, i) =>
          <div className="" key={i}>
            <div className="flex flex-col md:flex-row bg-black">
              <img className={`${blok.displayText ? 'md:w-2/3': 'w-full' } h-[300px] md:h-[600px] object-cover`} loading="lazy" src={item.image?.filename} alt={item.image?.alt} />
              {
              blok.displayText &&
              <div className="md:w-1/3 h-[300px] md:h-[600px] overflow-y-auto p-6 text-white bg-black text-left pr-10"
                style={{scrollbarColor: 'lightgray gray', backgroundColor: blok.bgColor?.color, color: blok.textColor?.color}}>
                <div className="font-serif text-lg pb-3">{item.title}</div>
                <div className={`${styles.richText}`} dangerouslySetInnerHTML={{__html: renderRichText(item.description)}} />
              </div>
              }
            </div>
          </div>
        )}</Slider>
        
        <button className="absolute left-0 bottom-[300px] md:bottom-[290px]" onClick={previous}>
          <img className="w-12" src="/icons/blog-carousel-arrow-left.svg" alt="Prev button"/>
        </button>
        
        <button className="absolute right-0 bottom-[300px] md:bottom-[290px]" onClick={next}>
          <img className="w-12" src="/icons/blog-carousel-arrow-right.svg" alt="Next button"/>
        </button>

        <div className="hidden md:flex absolute bottom-0 left-0 right-0 justify-center">
          {blok.carouselItems?.map((item, i) => (
            <div key={i} className={`mb-2`} onClick={() => sliderRef.current.slickGoTo(i)}>
              <img loading="lazy" src={item.image?.filename} alt={item.image?.alt} 
                className={`w-[80px] h-[40px] object-cover border-white border-2 m-2 hover:border-4 ${currentSlide === i ? 'border-4': ''}`} />
            </div>
          ))}
          <div className={`${blok.displayText ? 'md:w-1/3' : ''}`}></div>
        </div>
      </section>
    </div>
  )
}

export default BlogCarousel
